import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { setRetakeError } from "../Redux/usersSlice";
import { useDispatch } from "react-redux";
const RetakeProtectedRoute = ({ children }) => {
  const location = useLocation();
  const dispatch=useDispatch()
  const { retakeAuth,retakeToken } = useSelector((state) => state.user);

  const isOtpVerified =
    retakeToken &&
    retakeAuth?.mobile &&
    retakeAuth?.email;

  const RETAKE_PAGES = ["/selfie-retake", "/signature-retake", "/retake-otp"];

  // OTP page always allowed
  if (!isOtpVerified && location.pathname === "/retake-otp") {
    return children;
  }

  // Redirect to OTP & remember from where
  if (!isOtpVerified && RETAKE_PAGES.includes(location.pathname)) {
    return (
      <Navigate
        to="/retake-otp"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
};

export default RetakeProtectedRoute;
